
const Footer = () => {
  return (
    <div className="report-footer"></div>
  );
};

export default Footer;